import React from 'react';
import { useTranslation } from 'react-i18next';
import { Taxonomy } from '@uncinc/react-drupal-core';

import './style.scss';

const ViewThemes = ({ entities, onClick, showTitle = true, menuTeaser, isDesktop }) => {
  const { t } = useTranslation();

  return (
    <div className="ViewThemes">
      {showTitle && (
        <h2>{t('general.themes_title')}</h2>
      )}

      <div className="ViewThemes__Items">
        {entities.map((entity, index) => (
          <Taxonomy
            key={entity.getIn(['uuid', 0, 'value'], index)}
            viewMode="teaser"
            entity={entity}
            menuTeaser={menuTeaser}
            isDesktop={isDesktop}
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
};

export default ViewThemes;
